<template>
  <div style="width: 70vw; height: 70vh">
    <loading :loading.sync="loading" />

    <div v-if="!loading">
      <h1 class="md-display-2" style="color: black">Download Csv</h1>
      <span v-if="error" class="md-error" style="color: red">{{ error }}</span>

      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <h3 class="md-subheading">Data inicial</h3>
          <VueCtkDateTimePicker
            v-model="initialDate"
            :no-label="true"
            format="YYYY-MM-DD 00:00"
            formatted="LL"
          />
        </div>
        <div class="md-layout-item">
          <h3 class="md-subheading">Data final</h3>
          <VueCtkDateTimePicker
            v-model="finalDate"
            :no-label="true"
            format="YYYY-MM-DD 23:59"
            formatted="LL"
          />
        </div>
      </div>

      <h3 class="md-subheading">Selecione os sensores</h3>
      <md-checkbox
        v-for="sensor in sensores"
        :key="sensor.id"
        v-model="sensoresSelected"
        :value="sensor.id"
      >
        {{ sensor.codigoIntegracao }} - {{ sensor.descricao }}
      </md-checkbox>

      <div>
        <md-button class="md-primary md-raised" @click="download">
          Download
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/utils/http'
import { toUtcIsoString } from '@/utils/transform'

import Loading from '../Loading'

const fileDownload = require('js-file-download')

export default {
  name: 'EquipamentoDownloadCsv',
  components: { Loading },
  props: ['equipamentoId'],
  data() {
    return {
      loading: true,
      initialDate: null,
      finalDate: null,
      sensores: [],
      sensoresSelected: [],
      error: null,
    }
  },
  async beforeMount() {
    const data = await http.get('equipamento/' + this.equipamentoId)
    this.loading = false

    this.sensores = data.equipamento.sensores
  },
  methods: {
    async download() {
      if (this.initialDate === null || this.finalDate === null) {
        this.error = 'Dadas inválidas'
        return
      }

      if (new Date(this.initialDate) > new Date(this.finalDate)) {
        this.error = 'Data inicial maior que a data final'
        return
      }

      if (this.sensoresSelected.length === 0) {
        this.error = 'Nenhum sensor foi selecionado'
        return
      }

      this.error = null

      this.loading = true

      const value = await http.getDownload(
        'equipamento/download-csv/' + this.equipamentoId,
        {
          sensoresIds: this.sensoresSelected,
          dataInicio: toUtcIsoString(this.initialDate),
          dataFinal: toUtcIsoString(this.finalDate),
        }
      )

      this.loading = false

      fileDownload(value.data, 'flow.csv')
    },
  },
}
</script>

<style scoped></style>
